import React, { useMemo } from "react";
import { Button, Checkbox, Spinner } from "components";
import { useTranslate } from "hooks";
import {
  useIsFetching,
  useSelectedPasteItem,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";

export const PasteConfigurationControls = ({ title, id }) => {
  const translate = useTranslate();
  const isActionFetching = useIsFetching();
  const selectedPasteItem = useSelectedPasteItem();

  const isChecked = useMemo(
    () => selectedPasteItem.has(id),
    [selectedPasteItem, id],
  );

  return (
    <div className="d-flex gap-2 align-items-center position-absolute end-0 me-2 bg-gray-300">
      <Button className="px-1 text-nowrap" color="primary" disabled={isChecked}>
        {translate("PROJECT_NODE_PASTE")}
      </Button>
      {isActionFetching && <Spinner size="xxs" />}
      <Checkbox
        id={title}
        checked={isChecked}
        readOnly
        data-testid="checkbox-topology-item"
      />
    </div>
  );
};
